module.exports = __webpack_public_path__ + "static/media/app.b00f54f3.png";